/**
 * Get base64 hash of file
 *
 * @param {File} file
 * @return {Promise<string>}
 */
export function getBase64(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)

        reader.onload = () => {
            let encoded = (reader.result as string).toString().replace(/^data:(.*,)?/, '')

            if ((encoded.length % 4) > 0) {
                encoded += '='.repeat(4 - (encoded.length % 4))
            }

            resolve(encoded)
        }

        reader.onerror = error => reject(error)
    })
}
